import React , { useEffect } from "react";
import { useDispatch } from 'react-redux';
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import FooterLayout from "./components/layout/footer";

import NotAuthenticatedRoutes from "./NotAuthenticatedRoutes";

const Footer = () => (
  <footer className="footer_container">
    <FooterLayout />
  </footer>
);

function App() {
  const dispatch = useDispatch();
    // Accept.js loader inside your component or main entry file
  useEffect(() => {
    const acceptJsUrl = process.env.REACT_APP_ACCEPT_JS_SRC;

    if (!acceptJsUrl) {
      console.error('Missing Authorize.net configuration');
      return;
    }

    if (acceptJsUrl.includes('jstest') && process.env.REACT_APP_ENV === 'production') {
      console.error('Production Authorize.net configuration is incorrect.');
      return;
    }

    const script = document.createElement('script');
    script.src = acceptJsUrl;
    script.crossOrigin = 'anonymous';
    script.async = true;

    // Add nonce here — typically you get it from a meta tag or pass it via props/context
    const nonce = process.env.REACT_APP_NONCE;
    if (nonce) {
      script.setAttribute('nonce', nonce);
    }

    script.onload = () => {
      window.acceptLoaded = true;
    };
    script.onerror = () => {
      console.error('Failed to load Authorize.net script');
    };

    document.head.appendChild(script);
  }, [dispatch]);
  
  return (
    <div className="content">
      <NotAuthenticatedRoutes />
    </div>
  );
}

const AppContainer = () => {
  return [<App key="1"/>, <Footer key="2"/>];
};

export default AppContainer;
